import React  from 'react';
import { Typography } from '@mui/material'

const ProfessionalSpecialities = ({ fontSize = 12, specialities }) => {
    return (
        <Typography variant="subtitle2" fontSize={fontSize} fontWeight={700}>
            {specialities}
        </Typography>
    )
}

export default ProfessionalSpecialities;
